import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function fetchChamadosAutomaticosTodos() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/chamados-automaticos', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar chamados automáticos:', err);
    return [];
  }
}

export async function fetchChamadosAutomaticosAtivos() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/chamados-automaticos/ativos', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar chamados automáticos ativos:', err);
    return [];
  }
}

export async function createChamadoAutomatico(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/chamados-automaticos', body, { headers: getAuthHeaders() });
}

export async function updateChamadoAutomatico(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/chamados-automaticos/' + id, body, { headers: getAuthHeaders() });
}

export async function deleteChamadoAutomatico(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/chamados-automaticos/' + id, { headers: getAuthHeaders() });
}
